import React from 'react';
import { sectionTitle } from './estimateUi';

const inputClass =
  'w-full px-0 py-3 bg-transparent border-0 border-b border-border text-sm text-foreground placeholder:text-muted-foreground/50 focus:outline-none focus:border-foreground/40 transition-colors duration-300';

export default function StepContact({ isUA, contact, onChange }) {
  return (
    <div className="pt-10">
      <p className={sectionTitle}>{isUA ? 'Контакт' : 'Contact'}</p>
      <div className="space-y-5">
        <input
          type="text"
          name="name"
          autoComplete="name"
          value={contact.name}
          onChange={(e) => onChange('name', e.target.value)}
          placeholder={isUA ? 'Ім’я' : 'Name'}
          className={inputClass}
        />
        <input
          type="email"
          name="email"
          autoComplete="email"
          value={contact.email}
          onChange={(e) => onChange('email', e.target.value)}
          placeholder={isUA ? 'Email' : 'Email'}
          className={inputClass}
        />
        <input
          type="tel"
          name="phone"
          autoComplete="tel"
          value={contact.phone}
          onChange={(e) => onChange('phone', e.target.value)}
          placeholder={isUA ? 'Телефон' : 'Phone'}
          className={inputClass}
        />
        <input
          type="text"
          name="telegram"
          value={contact.telegram || ''}
          onChange={(e) => onChange('telegram', e.target.value)}
          placeholder={isUA ? 'Telegram @username (необов’язково)' : 'Telegram @username (optional)'}
          className={inputClass}
        />
        <textarea
          name="notes"
          rows={3}
          value={contact.notes}
          onChange={(e) => onChange('notes', e.target.value)}
          placeholder={isUA ? 'Коментар (необов’язково)' : 'Notes (optional)'}
          className={`${inputClass} resize-none min-h-[5rem]`}
        />
      </div>
    </div>
  );
}
